define(['moduler'], function (Moduler) {
    'use strict';

    return Moduler.create({
        defaults: {
            event: 'click', // the event to open the modal on
            contentElement: null, // selector for the  Modal component
            replaceHtmlAfterClose: true, // if true will restore the html to the initial state
            activeCssClass: 'is-active',
            targetUrl: '',
            target: '',
            validDomains: []
        },

        init: function () {
            var self = this;

            self.contentElement = document.querySelector(self.options.contentElement);
            self.contentElementHtml = self.contentElement.innerHTML;

            this.initEvents();
        },

        initEvents: function () {

            var self = this;

            document.querySelectorAll("a:not(.js-noCheck)").forEach(function (el) {
                el.addEventListener('click', function (e) {
                    try {
                        var currentHost = window.location.host;
                        var targetHost = this.host;
                        if (targetHost !== undefined && targetHost !== null && targetHost !== '' && targetHost !== currentHost) {
                            var link = this;
                            //Do whitelist check
                            if (!self.linkIsInWhiteList(targetHost, e, self, link)) {
                                e.preventDefault();
                                e.stopPropagation();
                            } else {
                                return true;
                            }
                        }
                    } catch (err) {
                        return true; // if this fails, we dont want to break every link on the page...
                    }
                });
            });

            // closing window by clicking close link
            self.contentElement.querySelectorAll('a:not(.js-acceptAndClose)').forEach(function (el) {
                el.addEventListener('click', function (e) {
                    e.preventDefault();
                    self.closeDialog();
                });
            });

            // closing window by clicking close link
            self.contentElement.querySelectorAll('.js-acceptAndClose').forEach(function (el) {
                el.addEventListener('click', function (e) {
                    e.preventDefault();
                    self.closeDialog();
                    var tab = window.open(self.options.targetUrl, '_blank');
                    tab.focus();
                });
            });
        },

        openDialog: function () {
            var self = this;

            // move modal element to body to avoid z-index issues.
            if (!self.contentElement.parentElement.matches('body')) {
                self.contentElement.remove();
                document.querySelector('body').appendChild(self.contentElement);
            }

            self.contentElement.classList.add(self.options.activeCssClass);

            var evt = new CustomEvent('modal-open');
            self.contentElement.dispatchEvent(evt);
            self.el.dispatchEvent(evt);
        },

        closeDialog: function () {
            var self = this;

            self.contentElement.classList.remove(self.options.activeCssClass);

            if (self.options.replaceHtmlAfterClose) {
                self.contentElement.innerHTML = self.contentElementHtml;
                Moduler.loadModules(self.contentElement);

                self.initEvents();
            }

            var evt = new CustomEvent('modal-close');
            self.contentElement.dispatchEvent(evt);
            self.el.dispatchEvent(evt);
        },

        linkIsInWhiteList: function (host, e, self, link) {
            var domain = host.replace('www.', '').toLowerCase();
            var isInWhiteList = false;
            for (var i = 0; i < self.options.validDomains.length; i++) {
                var validDomain = self.options.validDomains[i].toLowerCase();
                if (domain.endsWith(validDomain)) {
                    isInWhiteList = true;
                    break;
                }
            }
            
            if (!isInWhiteList) {
                self.options.targetUrl = link.getAttribute('href');
                self.options.target = link.getAttribute('target');
                self.openDialog();
            }
            return isInWhiteList;
        }
    });
});